module.exports = __webpack_public_path__ + "static/media/avitech_logo_colored.e7469149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/avitech_logo_colored.png
// module id = 578
// module chunks = 0